// ==============================|| MODELS ||============================== //

export interface ColumnsVisibilityModel {
  [key: string]: boolean;
}

export interface DataGridVisibility {
  columnsVisibilityModel: ColumnsVisibilityModel;
  setColumnsVisibilityModel: (value: ColumnsVisibilityModel) => void;
}

export interface DataGridDensity {
  density: GridDensity;
  setDensity: (value: GridDensity) => void;
}

export enum GridDensity {
  COMPACT = 'compact',
  STANDARD = 'standard',
  COMFORTABLE = 'comfortable'
}

export type GridValidRowModel = {
  [key: string | symbol]: any;
};

export type GridNativeColTypes =
  | 'string'
  | 'number'
  | 'date'
  | 'dateTime'
  | 'boolean'
  | 'singleSelect'
  | 'actions';

export interface HeaderFields {
  editable?: boolean;
  group?: string;
  minWidth?: number;
  cellClassName?: string;
  name: string;
  type: GridNativeColTypes;
}
